export default __webpack_public_path__ + "static/kids-expert-1a60badf7e4f184cb1067208e75a8429.png";